<template>
  <div v-if="resultCreatedBooking">
    <p class="py-1 font-medium-2 fw-700 text-success">
      {{ $t('flight.bookingSuccessful') }}
    </p>
    <b-tabs
      nav-class="bg-gray"
      pills
    >
      <b-tab
        :title="'Mã đặt chỗ'"
        title-item-class="fw-700"
        title-link-class="px-75 hover-bg-light-warning"
        class="pb-2"
        active
      >
        <div class="fw-700 d-flex align-items-center gap-1 mb-1">
          <span class="mr-25">{{ $t('flight.bookingCode') }}:</span>
          <BButton
            class="p-50 text-airline fw-700 font-medium-4"
            variant="outline-info"
            @click="handleGoToReservation(resultCreatedBooking.bookingId)"
          >
            {{ resultCreatedBooking.pnr }}
            <feather-icon
              class="ml-25 mb-25"
              icon="ExternalLinkIcon"
              size="14"
            />
          </BButton>
          <BButton
            variant="outline-info"
            class="px-50 py-75 rounded-lg fw-700 ml-1"
            @click="goToTicketFace(resultCreatedBooking.bookingId)"
          >
            {{ $t('reservation.exportTicket') }}
            <feather-icon
              class="ml-25"
              icon="ExternalLinkIcon"
              size="14"
            />
          </BButton>
        </div>

        <div class="fw-700">
          <span class="mr-25">
            {{ $t('flight.totalTickerFare') }}:
          </span>
          <span class="text-danger font-medium-2">
            {{ formatCurrency(resultCreatedBooking?.pricingInfo?.total) }}
          </span>
          <span class="ml-1 text-warning font-italic fw-600">
            (Chưa bao gồm phí dịch vụ)
          </span>
        </div>
      </b-tab>

      <b-tab
        title="1A Booking"
        title-item-class="fw-700 border-left-secondary border-right-secondary"
        title-link-class="px-75"
      >
        <ShortenBooking :shorten-text="resultCreatedBooking?.bookingImage || undefined" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BTabs, BTab, BButton,
} from 'bootstrap-vue'
import { capitalize, isEmpty } from 'lodash-es'
// import {
//   onBeforeUpdate,
// } from '@vue/composition-api'

import router from '@/router'

import { formatCurrency } from '@core/utils/filter'

import useClassBookingPro from './useClassBookingPro'

export default {
  components: {
    BTabs,
    BTab,
    BButton,

    ShortenBooking: () => import('./ShortenBooking.vue'),
  },
  setup() {
    // onBeforeUpdate(() => {
    //   console.log("UPDATE'ClassBookingProBookPrice' ")
    // })

    const {
      resultCreatedBooking,
    } = useClassBookingPro()

    function handleGoToReservation(bookingId) {
      // router.push({
      //   name: 'apps-reservations-modify',
      //   params: { id: bookingId },
      // })
      window.open(`/apps/bookings/${bookingId}`)
    }

    function goToTicketFace(bookingId) {
      window.open(`/apps/bookings/${bookingId}/ticket`)
    }

    return {
      resultCreatedBooking,
      capitalize,
      isEmpty,
      formatCurrency,
      goToTicketFace,
      handleGoToReservation,
    }
  },
}
</script>

<style lang="scss">

</style>
